/* eslint-disable no-unused-vars */
// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import createReducer from '../../../store/createReducer';
import * as types from './actionTypes';

const initialState = {
  paymentType: 2,
  total: {},
  message: {
    status: null,
    message: null,
  },
  isCollectionArranged: false,
  charities: [],
  charityId: null,
};

const confirmOrderReducer = createReducer(initialState, {
  [types.CONFIRM_REQUEST](state, action) {
    return {
      ...state,
      total: action.total,
    };
  },
  [types.CONFIRM_ORDER_FOR_CHARITY](state, action) {
    return {
      ...state,
      total: action.total,
    };
  },
  [types.CONFIRM_REQUEST_FAILED](state, action) {
    return {
      ...state,
      message: {
        ...action.data,
      },
    };
  },
  [types.CONFIRM_SET_MESSAGE](state, action) {
    return {
      ...state,
      message: {
        ...action.data,
      },
    };
  },
  [types.SET_PAYMENT_TYPE](state, action) {
    return {
      ...state,
      paymentType: action.data,
    };
  },
  [types.SET_IS_COLLECTION_ARRANGED](state, action) {
    return {
      ...state,
      isCollectionArranged: action.payload,
    };
  },
  [types.SELECT_CHARITY_ID](state, action) {
    return {
      ...state,
      charityId: action.charityId,
    };
  },
  [types.GET_CHARITIES](state, action) {
    return {
      ...state,
    };
  },
  [types.GET_CHARITIES_SUCCESS](state, action) {
    return {
      ...state,
      charities: action.charities,
    };
  },
});

export default confirmOrderReducer;
